import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import DesktopHeader from './Desktop/DesktopHeader';
import MobileHeader from './Mobile/MobileHeader';
import media from '../../styles/media.style';
import { NAVIGATION_MOBILE_HEIGHT, NAVIGATION_DESKTOP_HEIGHT } from '../../styles/variables.style';

const Container = styled.header`
  height: ${NAVIGATION_MOBILE_HEIGHT}px;

  ${media.tabletP`
    height: ${NAVIGATION_DESKTOP_HEIGHT}px;
  `};
`;

const Wrapper = styled.div`
  left: 0;
  position: fixed;
  top: 0;
  transform: translateY(${({ show }) => (show ? 0 : '-100%')});
  transition: transform 500ms ease-in-out;
  width: 100%;
  z-index: 100;
`;

class GlobalMenu extends React.Component {
  static defaultProps = {
    white: false,
    onlyLogo: false,
  };

  static propTypes = {
    screenSize: PropTypes.number.isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }).isRequired,
    onlyLogo: PropTypes.bool,
    white: PropTypes.bool,
  };

  state = {
    scroll: 0,
    show: true,
    top: true,
  };

  componentWillMount() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
  }

  shouldComponentUpdate(nextProp, nextState) {
    const { show, top } = this.state;
    return show !== nextState.show || top !== nextState.top;
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    const scroll = window.pageYOffset;
    const top = scroll === 0;
    const show = top || scroll < this.state.scroll;
    this.setState({ scroll, show, top });
  };

  render() {
    const { location, screenSize, onlyLogo, white } = this.props;
    const { show, top } = this.state;

    return (
      <Container>
        <Wrapper show={show}>
          {screenSize < 2 ? (
            <MobileHeader top={top} white={white} onlyLogo={onlyLogo} location={location} />
          ) : (
            <DesktopHeader top={top} white={white} onlyLogo={onlyLogo} show={show} />
          )}
        </Wrapper>
      </Container>
    );
  }
}

const mapState = state => ({
  screenSize: state.screenSize,
});

export default connect(mapState)(GlobalMenu);



// WEBPACK FOOTER //
// ./src/components/GlobalMenu/index.js